import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Input } from "antd";
import { overrideAllowClearProp } from "./utils.js";
import button_0 from "../button/index.js";
import { rootClass } from "./constant.js";
import classnames from "classnames";
const InputSearch = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { allowClear: inputAllowClear, enterButton: inputEnterButton, size, ...restProps } = props;
    const allowClear = overrideAllowClearProp(inputAllowClear);
    return /*#__PURE__*/ jsx(Input.Search, {
        ...restProps,
        size: size,
        enterButton: getEnterButtonIcon(inputEnterButton),
        allowClear: allowClear,
        ref: ref,
        className: classnames(rootClass, restProps.className)
    });
});
const getEnterButtonIcon = (enterButton)=>{
    if ('string' == typeof enterButton) return /*#__PURE__*/ jsx(button_0, {
        type: "primary",
        children: enterButton
    });
    return enterButton;
};
export { InputSearch };
